// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueParticles from 'vue-particles'
import VueClipboard from 'vue-clipboard2'
import * as echarts from 'echarts'
import moment from 'moment'
import './filter'
import './pages/components'

import './assets/css/init.css'
import './assets/css/common.scss'

import http from './http/http'
import hint from './assets/js/hint.js'
import crypto from './assets/js/crypto.js'
import debounce from './assets/js/debounce.js'

import Directive from './directive'
// 使用插件
Vue.use(Directive)
Vue.use(VueParticles)
Vue.use(VueClipboard)

Vue.prototype.$http = http
Vue.prototype.$hint = hint
Vue.prototype.$crypto = crypto
Vue.prototype.$debounce = debounce
Vue.prototype.$echarts = echarts
Vue.prototype.$moment = moment

Vue.config.productionTip = false

Vue.use(ElementUI)

router.beforeEach((to, from, next) => {
  store.commit('cancelReq', 'all')
  var token = localStorage.getItem('token')
  if (!token) {
    console.log(to)
    if (to.path === '/login') {
      next()
    } else {
      next('/login')
    }
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js